import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsOverviewService } from './admissions-overview.service';
import { AdmissionsOverviewTab1Part } from './tabs/tab-1/admissions-overview-tab-1.part';
import { AdmissionsOverviewTab2Part } from './tabs/tab-2/admissions-overview-tab-2.part';
import { AdmissionsOverviewViewsPart } from './views/overview-views.part';
@Component({
	selector: 'admissions-overview-page',
	standalone: true,
	imports: [
		AdmissionsOverviewTab1Part, AdmissionsOverviewTab2Part, AdmissionsOverviewViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-overview.page.html',
})
export class AdmissionsOverviewPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;
	public admissionsService = inject(AdmissionsAreaService);


	constructor(
		public pageService: AdmissionsOverviewService,
	) {
	}

	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}